'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A component that renders its children only when `this.props.if == true`.
 * Useful when you'd like to avoid using a ternary operator or a custom render method.
 */

exports.default = _react2.default.createClass({
  displayName: 'Show',

  propTypes: {
    children: _react2.default.PropTypes.node.isRequired,
    if: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      if: false
    };
  },
  render: function render() {
    if (!this.props.if) {
      return null;
    }

    return this.props.children;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.33/js/components/Show.js
// module id = 329
// module chunks = 0 1